import React, { useEffect, useState } from 'react';
import { object } from 'prop-types';

import { connect } from 'react-redux';

import moment from 'moment';

import MaterialTable from 'material-table';

import AppointmentContextMenu from './AppointmentContextMenu';
import DeleteAppointmentModal from '../../Modals/DeleteAppointmentModal';
import ManageAppointmentModal from '../../Modals/ManageAppointmentModal';

import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './Appointments.module.css';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

const Appointments = ({
    activeAppointment,
    activeItem,
    sendAppointmentNotification,
    ...props
}) => {

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [manageAppointmentModalOpen, setManageAppointmentModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
    }, [activeItem.id]);

    useEffect(() => {
        if (activeItem.appointments && activeItem.appointments.length === activeItem.appointmentCount) {
            setIsLoading(false);
        }
    }, [activeItem.appointments]);

    function renderMenu(rowData) {
        return (
            <AppointmentContextMenu
                activeItem={activeItem}
                appointment={rowData}
                onDeleteModalOpen={setDeleteModalOpen}
                onManageAppointmentModalOpen={setManageAppointmentModalOpen}
                sendAppointmentNotification={sendAppointmentNotification}
            />
        );
    }

    return (
        <div className={classes.Appointments}>
            <div className={classes.appointmentsTitle}>
                Appointments
            </div>
            <div className={classes.appointmentsTable}>
                <MaterialTable
                    options={{
                        paging:    false,
                        showTitle: false,
                        search:    false,
                        selection: false,
                        toolbar:   false
                    }}
                    columns={[
                        {
                            title:  'Appointment',
                            render: rowData => {
                                return `WO-${activeItem.workOrder}-${rowData.appointmentNum}`;
                            }
                        },
                        {
                            title:  'Date/Time',
                            render: rowData => moment.utc(rowData.scheduledDateTime).local().format('YYYY-MM-DD h:mm:ss A') + ' ' + getTimeZoneAbbr(rowData.scheduledDateTime, moment.tz.guess())
                        },
                        { title: 'Technician', field: 'primaryTechnicianName' },
                        { title: 'Status', field: 'status'},
                        {
                            title:  '',
                            render: rowData => renderMenu(rowData)
                        }
                    ]}
                    isLoading={isLoading}
                    data={activeItem.appointments}
                />
            </div>
            <DeleteAppointmentModal
                open={deleteModalOpen}
                close={() => setDeleteModalOpen(false)}
                title="Delete Appointment"
            />
            <ManageAppointmentModal
                open={manageAppointmentModalOpen}
                close={() => setManageAppointmentModalOpen(false)}
                title={`WO-${activeItem.workOrder}: Appointment WO-${activeItem.workOrder}-${activeAppointment.appointmentNum}`}
            />
        </div>
    );
};

Appointments.defaultProps = {
    activeItem: {}
};

Appointments.propTypes = {
    activeItem: object
};

const mapStateToProps = state => {
    return {
        activeAppointment: state.svcManagement.activeAppointment,
        activeItem:        state.svcManagement.activeItem
    };
};

const mapDispatchToProps = {
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Appointments);
